import styled from 'styled-components';

import {
  BasicSubtitle,
  BiggerSubtitle,
  type Size,
  SmallSubtitle,
  SmallTitle,
} from '@genially/design-system';

import { getInteractiveQuestionsRankingColor } from '../../utils/getInteractiveQuestionsRankingColor';
import { AvatarSize } from './constants';

const getWrapperSize = (size: Size, avatarSize: AvatarSize) => {
  if (avatarSize === AvatarSize.Small) {
    return size.units(4);
  }
  if (avatarSize === AvatarSize.Medium) {
    return size.units(5);
  }
  if (avatarSize === AvatarSize.Big) {
    return size.units(8);
  }

  return size.units(10);
};

interface WrapperProps {
  $size: AvatarSize;
  $hash?: number;
  $isActive?: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ theme: { color, size }, $size, $hash, $isActive }) => {
    const avatarSize = getWrapperSize(size, $size);

    return {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: avatarSize,
      height: avatarSize,
      borderRadius: '100%',
      border: `2px solid ${color.border.primary.hover()}`,
      outline: $isActive ? `2px solid ${color.border.reversed.default()}` : undefined,
      boxShadow: $isActive ? '0 0 1px 0 gray inset, 0 0 1px 0 gray' : undefined,
      flexShrink: 0,
      ...($hash
        ? {
            backgroundColor: getInteractiveQuestionsRankingColor($hash),
          }
        : {
            background:
              'linear-gradient(to right, rgba(27, 27, 28, 1.0) 50%, rgba(27, 27, 28, 0))',
          }),
    };
  },
);

export const StyledSmallSubtitle = styled(SmallSubtitle)(({ theme: { color } }) => ({
  color: color.content.primary.default(),
}));

export const StyledBasicSubtitle = styled(BasicSubtitle)(({ theme: { color } }) => ({
  color: color.content.primary.default(),
}));

export const StyledBiggerSubtitle = styled(BiggerSubtitle)(({ theme: { color } }) => ({
  color: color.content.primary.default(),
}));

export const StyledSmallTitle = styled(SmallTitle)(({ theme: { color } }) => ({
  color: color.content.primary.default(),
}));
